import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CloudUpload = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CloudUpload' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 M12,13 L12,22 M8,16.0000004 L11.9653427,11.9653429 L16,16.0000002' />
  </StyledIcon>
);
